class VariableFieldValue {
  constructor(variableName) {
    this.variableName = variableName;
  }
}
export {
  VariableFieldValue
};
//# sourceMappingURL=VariableFieldValue.js.map
